<template>
    <vertical-form-table v-model="form" v-bind="{ items }" @input="emit"></vertical-form-table>
</template>

<script>
import { attrs_input } from "@/assets/variables/attrs";
import { initExpoProgram } from "@/assets/variables/inits";

import VerticalFormTable from "@/components/dumb/vertical-form-table.vue";

const items = [
    {
        key: "date.programDisplay",
        type: "datetimes",
        term: "진행기간",
        required: true,
        coda: "프로그램의 전체 진행기간을 설정해 주세요.",
    },
    {
        key: "date.employerSubmit",
        type: "datetimes",
        term: "기업회원 접수기간",
        required: true,
        coda: "기업회원의 접수기간을 설정해 주세요.",
    },
    {
        key: "date.employeeSubmit",
        type: "datetimes",
        term: "개인회원 접수기간",
        required: true,
        coda: "개인회원의 접수기간을 설정해 주세요.",
    },
    {
        key: "date.matchingSubmit",
        type: "datetimes",
        term: "매칭기간",
        required: true,
        coda: "매칭기간을  설정해 주세요.\n매칭기간은 접수기간 종료 후 기업과 개인의 매칭을 진행하는 기간 입니다.\n기업회원과 개인회원 양쪽 모두 면접 매칭에 참여할 수 있습니다.\n매칭기간이 종료되면 추가 매칭이 불가능 합니다. \n매칭기간이 종료이후 면접 기간에 실제 면접이 진행됩니다.",
    },
    {
        key: "date.interviewSpans",
        type: "datetimes",
        term: "면접기간",
        required: true,
        coda: "면접기간을 설정해 주세요.\n면접기간에만 기업 면접 일정 입력이 가능합니다.\n면접기간에 매칭 기간에 등록된 면접 일정이 진행 됩니다.\n면접 완료 후 채용완료 시 채용등록 가능합니다.",
    },
].map((item) => ({
    ...item,
    attrs_input,
}));

export default {
    components: {
        VerticalFormTable,
    },
    props: {
        value: { type: Object, default: initExpoProgram },
    },
    data: () => ({
        form: initExpoProgram(),

        items,
    }),
    methods: {
        sync() {
            this.form = initExpoProgram(this.value);
        },
        emit() {
            this.$emit("input", this.form);
        },
    },
    watch: {
        value() {
            this.sync();
        },
    },
    mounted() {
        this.sync();
    },
};
</script>

<style>
</style>